// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__39JpX","cell":"ColumnAccessor_cell__2oBAL","firstCellAccent":"ColumnAccessor_firstCellAccent__scIcP"};